




















import AppCard from '~/components/AppCard.vue'
import Vue from 'vue'

export default Vue.extend({
  components: {
    AppCard,
  },
  props: ['username'],
  data() {
    return { dialog: false, email: this.username }
  },
  watch: {
    username() {
      this.email = this.username
    },
  },
  methods: {
    async handleReset(email: string) {
      this.$toast.info(
        `We will send an email to ${email} if an account exists.`
      )
      await this.$axios.get(
        `auth/send-authentication-email/${this.email}?type=resetPwd`
      )
    },
  },
})
